<template id="button">
    <button
        type="button"
        :class="buttonConfig.styleClass"
        :tabindex="buttonConfig.tabIndex"
        v-on:keydown.enter.prevent="onClicked"
        @click.prevent="onClicked"
        :aa-link="buttonConfig.aaLink"
        :aria-label="buttonConfig.ariaLabel ? buttonConfig.ariaLabel : buttonConfig.displayText"
        :role="buttonConfig.role"
        :aria-disabled="isDisabled">
        <slot name="beforeLabel"></slot>
        <div class="button__text">
            {{ buttonConfig.displayText }}
        </div>
    </button>
</template>

<script>
    export default {
        name: 'ButtonCta',
        props: {
            buttonConfig: {
                type: Object,
            },
        },

        methods: {
            onClicked(e) {
                if (this.buttonConfig.event && !this.buttonConfig.disabled) {
                    this.buttonConfig.event(e);
                }
            },
        },
        computed: {
            isDisabled() {
                return this.buttonConfig.styleClass.indexOf('disabled') !== -1;
            },
        },
    };
</script>
